import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Title
);

const PainChart = ({ painLevel }) => {
    const [chartData, setChartData] = useState({});
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        console.log(painLevel);
        if (Array.isArray(painLevel) && painLevel.length > 0) {
            // Filter to keep only the latest entry for each week_no
            const uniquePainData = painLevel.reduce((acc, current) => {
                const existing = acc.find(item => item.week_no === current.week_no);
                if (!existing || existing.date < current.date) {
                    return acc.filter(item => item.week_no !== current.week_no).concat(current);
                }
                return acc;
            }, []);

            const sortedPainData = uniquePainData.sort((a, b) => a.week_no - b.week_no);
            const labels = sortedPainData.map(item => `Week ${item.week_no}`);
            const data = sortedPainData.map(item => item.pain);

            setChartData({
                labels,
                datasets: [
                    {
                        data: data,
                        borderColor: '#FC6448',
                        backgroundColor: '#15B1D7',
                        pointBackgroundColor: '#FFF',
                        pointBorderColor: '#15B1D7',
                        pointRadius: 5,
                        borderWidth: 2,
                        spanGaps: true,
                    },
                ],
            });
            setIsDataLoaded(true);
            console.log(chartData);
        } else {
            setIsDataLoaded(false);
        }
    }, [painLevel]);

    const options = {
        scales: {
            x: {
                // title: {
                //     display: true,
                //     text: 'Week No',
                // },
            },
            y: {
                // title: {
                //     display: true,
                //     text: 'Pain',
                // },
                min: 0,
                max: 10,
                ticks: {
                    stepSize: 1,
                    callback: (value) => value.toFixed(0),
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
        },
        maintainAspectRatio: false,
    };

    return (
        <section className="metrics-section">
            <h3 className="card-title">Pain Level</h3>
            <div style={{ height: '200px', width: '100%'}}>
                {isDataLoaded ? (
                    <Line data={chartData} options={options} style={{ width: '100%' }} />
                ) : (
                    <p>No data available</p>
                )}
            </div>
        </section>
    );
};

export default PainChart;
